module.exports = __webpack_public_path__ + "img/minichatone.0e684240.svg";